var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          staticClass: "message-close-dialog",
          attrs: { "max-width": "300" },
          model: {
            value: _vm.isDialogOpen,
            callback: function ($$v) {
              _vm.isDialogOpen = $$v
            },
            expression: "isDialogOpen",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "h6-material quickytools-font" },
                [_vm._v(_vm._s(_vm.dialogTitle))]
              ),
              _vm.dialogMessage
                ? _c("v-card-text", { staticClass: "pre-line" }, [
                    _vm._v(_vm._s(_vm.dialogMessage)),
                  ])
                : _vm.htmlDialogMessage
                ? _c("v-card-text", { staticClass: "pre-line" }, [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.htmlDialogMessage) },
                    }),
                  ])
                : _vm._e(),
              _vm.positiveActionText || _vm.negativeActionText
                ? _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm.negativeActionText
                        ? _c(
                            "v-btn",
                            {
                              attrs: { outlined: "", color: "accent" },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.onActionPress(-1)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.negativeActionText))]
                          )
                        : _vm._e(),
                      _vm.positiveActionText
                        ? _c(
                            "v-btn",
                            {
                              attrs: { outlined: "", color: "accent" },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.onActionPress(1)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.positiveActionText))]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }